import { render, staticRenderFns } from "./ConfigurationResources.vue?vue&type=template&id=66e6ad78&scoped=true"
import script from "./ConfigurationResources.vue?vue&type=script&lang=js"
export * from "./ConfigurationResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e6ad78",
  null
  
)

export default component.exports